export default __webpack_public_path__ + "static/media/send_s.21f56e21.svg";